import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=3310268b&"
import script from "./UploadFile.vue?vue&type=script&lang=js&"
export * from "./UploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3310268b')) {
      api.createRecord('3310268b', component.options)
    } else {
      api.reload('3310268b', component.options)
    }
    module.hot.accept("./UploadFile.vue?vue&type=template&id=3310268b&", function () {
      api.rerender('3310268b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Upload/UploadFile.vue"
export default component.exports